// In separate file because VSCode code parsing has issues when this is part of a JSX component.
export const isGuid = (str: string) =>
  str.match(/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi);
